import { render, staticRenderFns } from "./component-outer-casing.vue?vue&type=template&id=b3076fa6&scoped=true"
import script from "./component-outer-casing.vue?vue&type=script&lang=js"
export * from "./component-outer-casing.vue?vue&type=script&lang=js"
import style0 from "./component-outer-casing.vue?vue&type=style&index=0&id=b3076fa6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3076fa6",
  null
  
)

export default component.exports